import { useHeySynclyHistory } from '@/entities/hey-syncly';
import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';

import type { HelpscoutInfo } from '../model';

type MailboxesPath = '/v1/workspaces/{workspace_id}/helpscout/mailboxes';
type UpdateParams = PathParams<MailboxesPath, 'patch'> &
  RequestBody<MailboxesPath, 'patch'>;

const normalizeMailboxIds = (mailbox_ids: number[] | null | undefined) => {
  if (!mailbox_ids) return null;
  return mailbox_ids.map(String);
};

/**
 * Helpscout mailbox 선택 상태 저장
 */
export const updateHelpscoutMailboxes = async ({
  workspace_id,
  mailbox_ids,
}: UpdateParams): Promise<HelpscoutInfo> => {
  const res = await v1ApiClient.patch(
    `/workspaces/${workspace_id}/helpscout/mailboxes`,
    {
      mailbox_ids: mailbox_ids.map(Number),
    },
  );

  return {
    ...res.data,
    mailbox_ids: normalizeMailboxIds(
      res.data.mailbox_ids as number[] | null | undefined,
    ),
  };
};

useHeySynclyHistory;
